export const DATE_PRESETS = {
  MTD: 'mtd',
  LAST_30: 'last_30',
  LAST_90: 'last_90',
  YTD: 'ytd',
  ALL: 'all',
  CUSTOM: 'custom',
} as const;

export type DatePreset = (typeof DATE_PRESETS)[keyof typeof DATE_PRESETS];

export const DATE_PRESET_LABELS: Record<DatePreset, string> = {
  [DATE_PRESETS.MTD]: 'Month to Date',
  [DATE_PRESETS.LAST_30]: 'Last 30 Days',
  [DATE_PRESETS.LAST_90]: 'Last 90 Days',
  [DATE_PRESETS.YTD]: 'Year to Date',
  [DATE_PRESETS.ALL]: 'All Time',
  [DATE_PRESETS.CUSTOM]: 'Custom',
};

export const ANALYTICS_CONFIG = {
  DEFAULT_PRESET: DATE_PRESETS.MTD as DatePreset,
  EARLIEST_DATE: '2024-01-01',
  CHART_HEIGHT: 250,
  CHART_COLORS: {
    VISITORS: {
      border: 'rgb(59, 130, 246)',
      background: 'rgba(59, 130, 246, 0.1)',
      point: 'rgb(59, 130, 246)',
    },
    MESSAGES: {
      border: 'rgb(16, 185, 129)',
      background: 'rgba(16, 185, 129, 0.1)',
      point: 'rgb(16, 185, 129)',
    },
  },
  CHART_STYLING: {
    tension: 0.4,
    borderWidth: 2,
    pointRadius: 3,
    pointHoverRadius: 5,
    pointBorderColor: '#ffffff',
    pointBorderWidth: 2,
  },
  CHART_TOOLTIP: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    padding: 12,
    bodySpacing: 4,
    bodyFontSize: 13,
    titleFontSize: 13,
    cornerRadius: 8,
  },
  CHART_GRID: {
    gridLineColor: 'rgba(0, 0, 0, 0.05)',
    xAxisTextColor: '#6b7280',
    yAxisTextColor: '#6b7280',
  },
};

export const KPI_LABELS = {
  TOTAL_MESSAGES: {
    title: 'Bot Responses',
    subtitle: 'AI-generated messages',
  },
  TOTAL_FLAGGED: {
    title: 'Flagged Chats',
    subtitle: 'Conversations requiring attention',
  },
  TOTAL_VISITORS: {
    title: 'Total Visitors',
    subtitle: 'Unique chat users',
  },
};

export const CHART_LABELS = {
  VISITORS: {
    title: 'Visitors Over Time',
    subtitle: 'Monthly visitor count for current year',
  },
  MESSAGES: {
    title: 'Bot Responses Over Time',
    subtitle: 'Monthly bot response count for current year',
  },
};
